module.exports = __webpack_public_path__ + "img/appbar_menu.a1185685.svg";